/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from 'react';
import { initialManagerState } from '../../types/userTypes';
import { initialEntitlementExceptionsState, initialEntitlementState, initialHolidayYearState, } from './states';
export const IntroSetupContext = createContext({
    holidayYearState: initialHolidayYearState,
    holidayYearDispatch: ((action) => { }),
    entitlementState: initialEntitlementState,
    entitlementDispatch: ((action) => { }),
    entitlementExceptionsState: initialEntitlementExceptionsState,
    entitlementExceptionsDispatch: ((action) => { }),
    managerState: initialManagerState,
    managerDispatch: ((action) => { }),
});
